import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=42adb0da&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=ts"
export * from "./EventEdit.vue?vue&type=script&lang=ts"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=42adb0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42adb0da",
  null
  
)

export default component.exports